export const METRIX_DATA = ' METRIX_DATA';
export const METRIX_BY_ID = ' METRIX_BY_ID';
export const METRIX_START = ' METRIX_START';
export const METRIX_END = ' METRIX_END';
export const TYPE_CONFIG_DATA = ' TYPE_CONFIG_DATA';
export const TYPE_CONFIG_DATA_ID = ' TYPE_CONFIG_DATA_ID';
export const RESET_COMMITMENT = 'RESET_COMMITMENT';
export const METRICS_CALCULATION = 'METRICS_CALCULATION';
export const CCCM_CALC_ANALYSIS_RESULTS_SUCCESS = 'CCCM_CALC_ANALYSIS_RESULTS_SUCCESS';
export const CCPC_CALC_ANALYSIS_RESULTS_SUCCESS = 'CCPC_CALC_ANALYSIS_RESULTS_SUCCESS';